import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import { pathConstructor } from '@/hooks/useCompany/utils';
import { getIndustryPerformance } from '@/redux/averages/selectors';
import { toPercentage } from '@/utilities/formatting';
import type { LocationState } from 'redux-first-router';

const stdDevToWeekly = (value: null | number | undefined) => {
  //Convert to weekly multiplying by sqrt(5) and turn into percentage
  if (value === null || value === undefined) return undefined;
  return value * Math.sqrt(5);
};

const stdDevToWeeklyFormatted = (value: null | number | undefined) => {
  const percent = stdDevToWeekly(value);
  return typeof percent === 'number' ? toPercentage(percent, 1) : 'n/a';
};

interface ReduxState {
  company: CompanyState;
  location: LocationState;
}
export function selector(state: ReduxState) {
  try {
    const path = pathConstructor(state.location);
    const companyId = state.company.urlToIdMapping[path];
    const analysis = state.company.analysis[companyId];
    const performanceSelector = getIndustryPerformance();
    const { market, industry } = performanceSelector(state, {
      companyId,
    });
    return {
      company: stdDevToWeekly(analysis.dailyReturnStdDev90d),
      companyFormatted: stdDevToWeeklyFormatted(analysis.dailyReturnStdDev90d),
      market: stdDevToWeekly(market?.returnDailyStdDev90Median),
      marketFormatted: stdDevToWeeklyFormatted(
        market?.returnDailyStdDev90Median
      ),
      industry: stdDevToWeekly(industry?.returnDailyStdDev90Median),
      industryFormatted: stdDevToWeeklyFormatted(
        industry?.returnDailyStdDev90Median
      ),
      marketP10: stdDevToWeekly(market?.dailyReturnStdDev90P10),
      marketP10Formatted: stdDevToWeeklyFormatted(
        market?.dailyReturnStdDev90P10
      ),
      marketP90: stdDevToWeekly(market?.dailyReturnStdDev90P90),
      marketP90Formatted: stdDevToWeeklyFormatted(
        market?.dailyReturnStdDev90P90
      ),
    };
  } catch (e) {
    return {
      company: undefined,
      companyFormatted: 'n/a',
      market: undefined,
      marketFormatted: 'n/a',
      industry: undefined,
      industryFormatted: 'n/a',
      marketP10: undefined,
      marketP10Formatted: 'n/a',
      marketP90: undefined,
      marketP90Formatted: 'n/a',
    };
  }
}
